<table *ngIf="forecastActivityReport.length" class="layout-fixed striped">
  <colgroup>
    <col class="width-5" />
    <col class="width-10" />
    <col class="width-10" />
    <col class="width-20" />
    <col class="width-10" />
    <col class="width-10" />
    <col class="width-5" />
    <col class="width-5" />
    <col class="width-10" />
    <col class="width-35" />
  </colgroup>
  <thead>
    <tr>
      <th colspan="10">
        <h3>{{projectSetup.subprojectConfiguration.customNames.forecastTabName}}</h3>
      </th>
    </tr>
  </thead>
  <tbody class="secondary-header">
    <tr>
      <td class="text-center">{{StaticMessage.PriorityColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportForecastActivities.colCategory">Category</td>
      <td>{{StaticMessage.ActivityGroupColumn | staticMessage}}</td>
      <td>{{StaticMessage.ActivityColumn | staticMessage}}</td>
      <td class="text-center">{{StaticMessage.LocationColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportForecastActivities.colDate">Date</td>
      <td class="text-center">{{StaticMessage.StartColumn | staticMessage}}</td>
      <td class="text-center">{{StaticMessage.FinishColumn | staticMessage}}</td>
      <td class="text-center">{{StaticMessage.DurationColumn | staticMessage}}</td>
      <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
    </tr>
  </tbody>
  <tbody *ngFor="let activity of forecastActivityReport; index as activityIndex">
    <tr>
      <td class="text-center accent">{{activityIndex + 1}}</td>
      <td class="text-center">{{activity.forecastCategoryName}}</td>
      <td>{{activity.activityGroupName}}</td>
      <td>
        <strong></strong>
        {{activity.activityName}}
      </td>
      <td class="text-center">{{activity.locationName}}</td>
      <td class="text-center">{{activity.date | date : 'dd-MM-yy'}}</td>
      <td class="text-center">{{activity.start | customTimeDisplay}}</td>
      <td class="text-center">{{activity.finish | customTimeDisplay}}</td>
      <td class="text-center accent">{{activity.start | duration : activity.finish}}</td>
      <td>
        {{activity.comment}}
        <ng-container *ngIf="activity.customDataReport.length">
          <label>{{StaticMessage.CustomDataLabel | staticMessage}}:</label>
          <table class="layout-fixed">
            <colgroup>
              <col class="width-45" />
              <col class="width-20" />
              <col class="width-35" />
            </colgroup>
            <tbody>
              <tr *ngFor="let customData of activity.customDataReport">
                <td>
                  {{customData.name}}
                  <br />
                </td>
                <td class="text-center">{{customData.value}}</td>
                <td>{{customData.comment}}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </td>

      <td class="text-center"></td>
    </tr>
    <tr class="text-muted" *ngFor="let subactivity of activity.subActivitiesReport; index as subActivityIndex">
      <td class="text-center accent">{{activityIndex + 1}} . {{subActivityIndex + 1}}</td>
      <td></td>
      <td></td>
      <td colspan="3">{{subactivity.name}}</td>
      <td class="text-center">{{subactivity.start | customTimeDisplay}}</td>
      <td class="text-center">{{subactivity.finish | customTimeDisplay}}</td>
      <td class="text-center">{{subactivity.start | duration : subactivity.finish}}</td>
      <td colspan="4"></td>
    </tr>
  </tbody>
</table>
